<template>
  <WrapperBox :tag="'footer'" :className="'Ftr'">
    <FooterDescription class="Ftr__description"></FooterDescription>
    <FooterLinks class="Ftr__links"></FooterLinks>
  </WrapperBox>
</template>

<script setup>
  import WrapperBox from "@shared/UI/Wrappers/WrapperBox/WrapperBox.vue";
  import FooterDescription from "@widgets/Footer/components/FooterDescription/FooterDescription.vue"
  import FooterLinks from "@widgets/Footer/components/FooterLinks/FooterLinks.vue"
</script>

<style lang="scss">
  @import "./styles";
</style>
